import { Component, Input } from '@angular/core';
import { ProgressbarConfig } from './progressbar.config';
import { isBs3 } from '../utils';


export class ProgressbarComponent {
  /** if `true` changing value of progress bar will be animated (note: not supported by Bootstrap 4) */
   public animate:boolean;
  /** maximum total value of progress element */
   public max:number;
  /** provide one of the four supported contextual classes: `success`, `info`, `warning`, `danger` */
   public type:string;
  /** current value of progress bar. Could be a number or array of objects like {"value":15,"type":"info","label":"15 %"} */
   public set value(value: number | any[]) {
    this.isStacked = Array.isArray(value);
    this._value = value;
  };
  public isStacked: boolean = false;
  public _value: number | any[];
  public get isBs3(): boolean {
    return isBs3();
  }

  public constructor(config: ProgressbarConfig) {
    Object.assign(this, config);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'progressbar',
  template: `
    <div progress [animate]="animate" [max]="max" [style.width]="!isBs3 ? '100%' : 'auto'">
      <bar [type]="type" [value]="_value" *ngIf="!isStacked">
          <ng-content></ng-content>
      </bar>
      <template [ngIf]="isStacked">
        <bar *ngFor="let item of _value" [type]="item.type" [value]="item.value">{{item.label}}</bar>
      </template>
    </div>
  `,
  styles: [`
    :host {
      width: 100%;
    }
  `]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ProgressbarConfig, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animate': [{ type: Input },],
'max': [{ type: Input },],
'type': [{ type: Input },],
'value': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
